/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import * as React from 'react';
import { Formik } from 'formik';
import { Typography } from '@mui/material';
import * as Yup from 'yup';
import { toast } from 'react-toastify'; 
import { useParams } from 'react-router-dom';
import OrgAppUserForm from './OrgAppUserForm';
import { useDispatch } from 'react-redux';
import { createApplicationUser } from '../../../../../../../../services/application/ApplicationUsers';
import { getAllApplicationUsers } from '../../../../../../../../store/reducers/applicationUsers/applicationUsersAction';

const OrgAppUserCreation = ({  handleClose }) => {
    const { orgid } = useParams();
    const dispatch = useDispatch()
    const handleSubmit = async ({ organizationID, organizationApplicationID ,getChkdID ,roleID},{setSubmitting}) => {
        setSubmitting(true);
        try{
            await createApplicationUser({ organizationID, organizationApplicationID,getChkdID ,roleID});
            toast.success('Organization Application User was registred successfully');
            handleClose();
            await dispatch(getAllApplicationUsers()).unwrap();
            setSubmitting(false);

        }catch(error){
            toast.error(error?.response?.data?.error?.message);
            setSubmitting(false);
        } 
    }

    return (
        <>
            <Typography variant='h2' color="primary" align='center' style={{ margin: '30px' }}>Organization Application User Registration</Typography>
            <Formik
                initialValues={{
                    organizationID: orgid ? orgid :'',
                    organizationApplicationID: '',
                    getChkdID: "",
                    roleID: ""
                }}
                validationSchema={Yup.object().shape({
                    organizationID: Yup.string().required('Organization is required.'),
                    organizationApplicationID: Yup.string().required('Organization Application  is required.'),
                    getChkdID: Yup.string().required('User is required.'),
                    roleID: Yup.string().required('Role is required.'),

                })}
                onSubmit={(
                    values,{setSubmitting}
                ) => {
                     handleSubmit(values,{setSubmitting})
                }
                }
            >
                {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                    <OrgAppUserForm
                        values={values}
                        handleBlur={handleBlur}
                        handleChange={handleChange}
                        setFieldValue={setFieldValue}
                        isSubmitting={isSubmitting}
                        handleClose={handleClose}
                        errors={errors}
                        touched={touched} />
                )}
            </Formik>
        </>
    )

}

 
 
export default OrgAppUserCreation;